import { downloadUrlParser } from "./Tools/tools"

export const onViewFile = (file: any) => {
  window
    .open(
      downloadUrlParser({
        path: file?.path,
        filename: file?.filename,
        originalname: file?.originalname,
        mimetype: file?.mimetype,
      }),
      "_blank",
    )
    ?.focus()
}
